import { render } from "./indexnavInvite.vue?vue&type=template&id=4b233e0a&scoped=true&ts=true"
import script from "./indexnavInvite.vue?vue&type=script&lang=ts"
export * from "./indexnavInvite.vue?vue&type=script&lang=ts"

import "./indexnavInvite.vue?vue&type=style&index=0&id=4b233e0a&scoped=true&lang=scss"

import exportComponent from "D:\\project\\H5-NEW\\H5\\APP内嵌H5\\rs-h5app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b233e0a"]])

export default __exports__